import type { IssueWorkflowOutDto } from 'shared/domain/workflow/types';

export function buildWorkflowContentSignature(
  workflow: IssueWorkflowOutDto | null
): string {
  if (!workflow) {
    return '';
  }

  const stagesSignature = (workflow.stages ?? [])
    .map((stage) => `${stage._id}:${stage.modifiedAt ?? ''}`)
    .join('|');

  return [workflow.name, String(workflow.isLocked), stagesSignature].join('||');
}
